// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import {DatePicker, Icon, Select} from "antd";
import {MaterialIcon} from "../utils/Icon";

// Import Styles
import '../../assets/styles/components/page-header.scss';

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";

// Import components
import {LinkButton} from "../buttons/buttons";
import {InputGroup} from "../uiElements/inputGroup";
import { IconSearch } from "../../assets/images";


class PageHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsData: {
                start: '',
                end: '',
                network: undefined,
                station: undefined,
                address: undefined,
                type: undefined,
            },
            filtersWrapperOpen: false
        }
        this.handleChangeData = this.handleChangeData.bind(this);
        this.changeFilter = this.changeFilter.bind(this);
        this.toggleFilters = this.toggleFilters.bind(this);
    }

    handleChangeData(field, value) {
        this.setState({
            fieldsData: {
                ...this.state.fieldsData,
                [field]: value
            }
        })
    }

    changeFilter({name, value}) {
        this.setState({
            fieldsData: {
                ...this.state.fieldsData,
                [name]: value
            }
        });
    }

    toggleFilters() {
        const {filtersWrapperOpen} = this.state
        this.setState({
            fieldsData: {
                ...this.state.fieldsData,
            },
            filtersWrapperOpen: !filtersWrapperOpen
        })
    }

    render() {
        const {
            linkTitle, addingLink, rightPartProps,
            search, searchValue, filters,
        } = this.props;
        const {filtersWrapperOpen} = this.state
        return <div className="content-header">
            <div className={"search-row-with-add-button"}>
                <div className="search_box">
                    {search && <>
                        <button type="button" className=" search_btn" onClick={this.props.searchItems}>
                            <IconSearch title={''}/>
                        </button>
                        <InputGroup inputType="input"
                                    type="text"
                                    placeholder="Որոնել"
                                    name="text"
                                    maxLength={256}
                                    onKeyDown={(e) => e && e.key === 'Enter' && this.props?.searchItems?.()}
                                    value={searchValue || ''}
                                    onChange={({value}) => this.props?.getSearchValue?.(value)}/>
                    </>}
                </div>
                <div>
                    {rightPartProps? rightPartProps: (
                        addingLink && <LinkButton title={linkTitle}
                                                  link={addingLink}
                                                  className={"header-btn"}/>
                    )}
                </div>
            </div>
            <div className={"down-part"}>
                {filters && <LinkButton title={<> <MaterialIcon icon="clear"/> <span>Ֆիլտրել</span> </>}
                                        cb={this.toggleFilters}
                                        className={`header-btn filter-btn ${filtersWrapperOpen ? "open-filters-btn" : ""}`}/>}
            </div>
            <div className={`filters-wrapper ${filtersWrapperOpen ? "open" : ""}`}>{filtersWrapperOpen && filters}</div>
        </div>
    }
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader)
